import { Box } from "@mui/material";
import { useMemo } from "react";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import PopOverCreator from "@/utils/util-components/PopOverCreator";
import {
  AppSwitcherIcon,
  ECARE_APPS,
  NAV_BAR_COLORS,
  NAV_BAR_LABELS,
  NAV_BAR_LAYOUT,
  NAV_BAR_TYPOGRAPHY,
} from "../nav-bar-constant";
import type { EcareApp } from "../nav-bar-types";
import { groupEcareApps } from "../nav-bar-utils";
import AppSwitcherTile from "./AppSwitcherTile";
import NavBarIconButton from "./NavBarIconButton";

export interface AppSwitcherPopOverProps {
  apps?: readonly EcareApp[];
}

const AppSwitcherPopOver = ({ apps = ECARE_APPS }: AppSwitcherPopOverProps) => {
  const sections = useMemo(() => groupEcareApps(apps), [apps]);

  return (
    <PopOverCreator
      paperSx={{
        mt: NAV_BAR_LAYOUT.MENU_OFFSET_Y,
        width: NAV_BAR_LAYOUT.APP_SWITCHER_WIDTH,
        p: NAV_BAR_LAYOUT.APP_SWITCHER_PADDING,
        borderRadius: NAV_BAR_LAYOUT.APP_SWITCHER_RADIUS,
        boxShadow: NAV_BAR_LAYOUT.APP_SWITCHER_SHADOW,
        bgcolor: NAV_BAR_COLORS.APP_SWITCHER_BG,
      }}
      triggerComponent={
        <NavBarIconButton title={NAV_BAR_LABELS.APP_SWITCHER_TOOLTIP}>
          <AppSwitcherIcon sx={{ fontSize: NAV_BAR_LAYOUT.ACTION_ICON_SIZE }} />
        </NavBarIconButton>
      }
      contentComponent={
        <Flex flexDirection="column" gap={NAV_BAR_LAYOUT.APP_SECTION_GAP}>
          {sections.map((section) => (
            <Box key={section.group}>
              <Text
                fontSize={NAV_BAR_TYPOGRAPHY.LABEL_FONT_SIZE}
                fontWeight={NAV_BAR_TYPOGRAPHY.APP_NAME_FONT_WEIGHT}
                c={NAV_BAR_COLORS.APP_SECTION_TITLE}
                mb={NAV_BAR_LAYOUT.APP_SECTION_TITLE_GAP}
              >
                {section.label}
              </Text>
              <Box
                sx={{
                  display: "grid",
                  gap: NAV_BAR_LAYOUT.APP_GRID_GAP,
                  gridTemplateColumns: `repeat(${NAV_BAR_LAYOUT.APP_GRID_COLUMNS}, 1fr)`,
                }}
              >
                {section.apps.map((app) => (
                  <AppSwitcherTile key={app.id} app={app} />
                ))}
              </Box>
            </Box>
          ))}
        </Flex>
      }
    />
  );
};

export default AppSwitcherPopOver;
